'use strict';

var _ = require('lodash');
var ModelToPayloadTransformerService = function ModelToPayloadTransformerService(StrategyAction, StrategyCondition, strategyConstants) {
  var CLASS_CLOSURE = strategyConstants.CLASS_CLOSURE;
  function transform(strategy, strategyConditions) {
    var groups = [];
    strategy.actionList.forEach(function (action) {
      if (action.daysToDeparture || action.loadFactor) {
        var actions = [];
        var conditions = [];
        actions.push(new StrategyAction({
          action: 'Set',
          field: 'authorizationModel',
          value: '0'
        }));
        conditions.push(createStrategyCondition(CLASS_CLOSURE.CLASS_NAME_FIELD, action.fareBasisCode, 'PRODUCT', '='));
        if (action.daysToDeparture) {
          conditions.push(createStrategyCondition(CLASS_CLOSURE.DTD_FIELD, +action.daysToDeparture, 'CLOSURE_GROUP_DTD', '<='));
        }
        if (action.loadFactor) {
          var loadFactorPctValue = action.loadFactor / 100;
          conditions.push(createStrategyCondition(CLASS_CLOSURE.LOAD_FACTOR_FIELD, loadFactorPctValue, 'CLOSURE_GROUP_LOAD', '>='));
        }
        groups.push({
          actions: actions,
          conditions: conditions,
          level: CLASS_CLOSURE.LEVEL
        });
      }
    });
    return {
      strategy: {
        groups: groups,
        name: strategy.name,
        description: strategy.description,
        "public": strategy["public"],
        quickRule: strategy.quickRule || false,
        level: CLASS_CLOSURE.LEVEL,
        basis: strategy.basis,
        type: strategyConstants.PANEL_TYPE.OPTIMIZATION,
        usage: strategy.usage,
        createdBy: strategy.createdBy,
        createdAt: strategy.createdAt,
        createdDate: strategy.createdDate,
        technicalId: strategy.technicalId
      },
      commonConditions: _.filter(strategyConditions, function (condition) {
        return condition.operator;
      })
    };
  }
  function createStrategyCondition(field, value, category, operator) {
    return new StrategyCondition({
      category: category,
      operator: operator,
      field: field,
      leftOperand: value,
      rightOperand: null,
      quantifier: ''
    });
  }
  return {
    transform: transform
  };
};
ModelToPayloadTransformerService.$inject = ['StrategyActionFactory', 'StrategyConditionFactory', 'StrategyConstants'];
module.exports = ModelToPayloadTransformerService;